<template>
    <div>

        <div class="popup-property-details">

            <DxScrollView
                    :height="420"
                    :width="600"
                    direction="both">
                <DxForm :form-data="formData" :col-count="2"  validation-group="customerData">
                    <!--用户UId和标签-->
                    <DxSimpleItem data-field="UID" :col-span="2">
                        <DxLabel text="接收消息的用户UID,多个UID用英文状态的,分隔" />
                    </DxSimpleItem>

                    <DxSimpleItem data-field="TID" :col-span="2">
                        <DxLabel text="接收消息的某个标签,多个TID用英文状态的,分隔" />
                        <template #default>
                            <div>
                                <DxSelectBox
                                        :items="positionOptions"
                                        :show-clear-button="true"
                                        @value-changed="changeTagsBox" display-expr="name" value-expr="id"  value-change-event="keyup"
                                />
                            </div>
                        </template>
                    </DxSimpleItem>

                    <DxSimpleItem data-field="infoUrl" :col-span="2">
                        <DxLabel text="用户详情" />
                    </DxSimpleItem>


                    <!--推送周期start-->
                    <DxSimpleItem data-field="startTime" :col-span="1" editor-type="dxDateBox" :editor-options="{type: 'datetime', displayFormat: 'yyyy-MM-dd HH:mm:ss'}" >
                        <DxLabel text="活动开始时间" />
                    </DxSimpleItem>

                    <DxSimpleItem data-field="endTime" :col-span="1"  editor-type="dxDateBox" :editor-options="{type: 'datetime', displayFormat: 'yyyy-MM-dd HH:mm:ss'}">
                        <DxLabel text="活动结束时间" />
                    </DxSimpleItem>


                    <DxSimpleItem data-field="transmitFre"  :col-span="1" >
                        <DxLabel text="推送周期" />
                        <template #default>
                            <div>
                                <!--                                <DxTagBox :data-source="activityCycleNumber"></DxTagBox>-->
                                <DxTagBox :items="activityCycleNumber" displayExpr="text" valueExpr="value" :show-selection-controls="true" :search-enabled="true" palceholder="请选择"
                                          value-change-event="keyup" @value-changed="changeNumberBox"/>
                            </div>
                        </template>
                    </DxSimpleItem>

                    <DxSimpleItem data-field="transmitTime" :col-span="1"  editor-type="dxDateBox" :editor-options="{type: 'time', displayFormat: 'HH:mm:ss'}" >
                        <DxLabel text="推送时间" />
                    </DxSimpleItem>
                    <!--推送周期end-->
                </DxForm>

                <div>
                    <!--                        <div>{{modeMap}}</div>-->
                    <DxForm  :col-count="2" :form-data="formData2"  >
                        <DxGroupItem  v-for="(mode,index) in modeMap" :key="index" >
                            <DxSimpleItem :data-field="mode.itemValue">
                                <DxLabel :text="mode.itemName" />
                            </DxSimpleItem>
                        </DxGroupItem>
                    </DxForm>
                </div>


                <!--                    <DxGroupItem  v-for="(mode,index) in modeMap" :key="index" >-->
                <!--                        <DxSimpleItem :data-field="mode.itemValue">-->
                <!--                            <DxLabel :text="mode.itemName" />-->
                <!--                        </DxSimpleItem>-->
                <!--                    </DxGroupItem>-->



            </DxScrollView>


            <div class="form_submit">
                <DxButton @click="submitFrom" class="my_submit">发送</DxButton>
            </div>
        </div>

    </div>
</template>

<script>
    import notify from "devextreme/ui/notify";
    import DxScrollView from 'devextreme-vue/scroll-view';
    import { activityCycle_number } from '../js/data.js';
    import DxTagBox from 'devextreme-vue/tag-box';

    export default {
        name: "marketing_message",
        components:{
            DxScrollView,DxTagBox
        },

        computed: {
            companySelectorLabelMode() {
                if (this.labelMode === 'outside') {
                    return 'hidden';
                }
                return this.labelMode;
            },
        },
        props:{
            activity:{},
        },
        watch:{
            activity(newValue,oldValue){

                if(newValue != oldValue){
                    this.init()
                }
            }
        },
        mounted() {
            this.init()
        },
        data(){
            return{
                modeMap:[],
                positionOptions:[],
                formData: {},
                formData2:{},
                param:{},
                activityCycleNumber: activityCycle_number,
                employee: {
                    firstName: "John",
                    lastName: "Heart",
                    position: "CEO",
                    officeNo: 901
                }
            }
        },
        methods:{
            init: async function(){
                this.param.wechatId=this.activity.wxId
                this.param.modeId=this.activity.modeId
                this.param.marketingId = this.activity.marketingId
                // 获取公众号用户标签
                await  this.$http.get_all_tags_pu({"appId":this.activity.wxId}).then( res=>{
                    this.positionOptions = res.data
                })
                await this.$http.get_model_info({"appId":this.activity.wxId,"modelId":this.activity.modeId}).then(res=>{
                    if(res.status == "success"){
                        let modelMap = res.data[0].content
                        for(let key in modelMap){
                            let temp={
                                "itemValue": modelMap[key],
                                "itemName" : key
                            }
                            this.modeMap.push(temp)
                        }
                    }
                })
            },
            submitFrom: async function(){
                //数据校验
                if(this.formData.startTime == undefined || this.formData.endTime == undefined){
                    notify("活动时间必填", "error", 2000);
                    return ;
                }
                if(new Date(this.formData.startTime).getTime() >= new Date(this.formData.endTime).getTime()){
                    notify("开始时间不能大于等于结束时间", "error", 2000);
                    return ;
                }

                if(this.param.tidStr == undefined && this.formData.UID == undefined){
                    notify("用户UID和用户标签为空将发给该微信公众号所有人", "success", 2000);
                }

                //数据提交
                this.loading = true;
                this.param.uidStr = JSON.stringify([this.formData.UID])
                this.param.infoUrl= this.formData.infoUrl
                this.param.startTime = this.formatDate(this.formData.startTime)
                this.param.endTime =  this.formatDate(this.formData.endTime)
                this.param.transmitTime = this.getTime(this.formData.transmitTime)
                this.param.transmitFre =  JSON.stringify(this.transmitFre)

                this.param.sendConnet = this.formData2




                let that = this
                this.$http.send_activity_message(this.param).then(res =>{
                    //console.log(res)
                    if(res.status == "success"){
                        notify(res.msg, "success", 2000);
                    }
                    notify(res.msg, "error", 2000);

                    that.$emit("closeProp")

                    that.param = []
                    that.formData = []
                    that.formData2 = []
                })

            },

            changeTagsBox(e){
                this.param.tidStr=JSON.stringify([e.value])
            },
            changeNumberBox(e){
                this.transmitFre = e.value
            },
            formatDate(date) {
                var date = new Date(date)
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var minute = date.getMinutes();
                var second = date.getSeconds();
                return year + "-" + this.formatTen (month) + "-" + this.formatTen (day)+ " " +this.formatTen (hour)+ ":" +this.formatTen (minute)+ ":" +this.formatTen (second);
            },
            getTime(date){
                var date = new Date(date)
                var hour = date.getHours();
                var minute = date.getMinutes();
                var second = date.getSeconds();
                return this.formatTen (hour)+ ":" +this.formatTen (minute)+ ":" +this.formatTen (second);
            },
            formatTen(num) {
                return num > 9 ? (num + "") : ("0" + num);
            },
        }
    }
</script>

<style scoped>

</style>